(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/tipset-actionbar.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/tipset-actionbar.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.TipsenActionbar = Backbone.Marionette.View.extend({
    el: '#actionbar-content',
    modelEvents: {
      showActionBarSystem: 'showActionbarSystem',
      showActionbarXpert: 'showActionbarXpert',
      removeActionBar: 'removeActionBar'
    },

    initialize: function() {
      this.listenTo(svs.tipset.models.play, 'change', function(e) {
        if (!e.changed.isReduceMode) {
          return;
        }

        svs.sport.actionbar.hide();
      });
    },

    showActionbarSystem: function() {
      var actionbarOptions = {
        closeButton: false,
        cssClass:
          'actionbar-' + svs.tipset.models.gameDefinitions.get('htmlClass'),
        leftButton: {
          type: 'text',
          text: 'System ' + this.model.get('systemName'),
          visible: true
        },
        centerButton: {
          type: 'link',
          icon: 'icon-default icon-300 icon-rensa-app',
          visible: true,
          callback: function() {
            svs.tipset.models.systems.clear();
            svs.tipset.views.actionbar.removeActionBar();
            svs.tipset.models.systems.setCurrentSystem(null);
          }
        }
      };
      if (this.model.get('systemName') !== undefined) {
        svs.sport.actionbar.show(actionbarOptions, this);
      }
    },

    showActionbarXpert: function() {
      var actionbarOptions;
      var actionBar;
      if (this.model.get('xpertenGenSystem')) {
        var xpertenText = '';
        if (this.model.get('xperten')) {
          xpertenText = this.model.get('xperten').size + ' rader';
        }

        xpertenText = this.model.get('systemName') || xpertenText;

        actionbarOptions = {
          closeButton: false,
          cssClass:
            'actionbar-' + svs.tipset.models.gameDefinitions.get('htmlClass'),
          leftButton: {
            type: 'text',
            text: 'Xperten ' + xpertenText,
            visible: true
          },
          centerButton: {
            type: 'link',
            icon: 'icon-default icon-300 icon-refresh',
            visible: true,
            callback: function() {
              this.model.reloadXperten();
            }
          },
          rightButton: {
            type: 'link',
            text: '',
            icon: 'icon-default icon-300 icon-rensa-app',
            visible: true,
            callback: function() {
              this.clearAllSelections();
            }
          },
          bottomView: {
            type: '',
            text: this.model.get('genXpertenInfoText')
          },
          bottomButton: {
            type: 'button',
            text: 'Generera system',
            visible: true,
            disabled: this.model.get('genXpertenIsActive'),
            callback: function() {
              this.model.generateXperten();
            }
          }
        };

        setTimeout(function() {
          actionBar = document.getElementsByClassName('actionbar')[0];
          if (actionBar) {
            actionBar.classList.add('actionbar-clear-bottom-border');
          }
        });
      } else {
        actionbarOptions = {
          cssClass:
            'actionbar-' + svs.tipset.models.gameDefinitions.get('htmlClass'),
          leftButton: {
            type: 'button',
            text:
              '<span class="padding-xs-right">Xperten</span>' +
              this.getCenterButtonText(),
            visible: true,
            callback: function() {
              svs.tipset.views.contextualmenu.onXperten();
            }
          },
          centerButton: {
            type: 'link',
            icon: 'icon-default icon-300 icon-refresh',
            visible: true,
            callback: function() {
              this.model.reloadXperten();
            }
          },
          rightButton: {
            type: 'link',
            text: '',
            icon: 'icon-default icon-300 icon-rensa-app',
            visible: true,
            callback: function() {
              this.clearAllSelections();
            }
          }
        };
      }

      svs.sport.actionbar.show(actionbarOptions, this);
    },

    clearAllSelections: function() {
      if (svs.tipset.models.play.get('isSingleRow')) {
        svs.tipset.collections.boardCollections.clearAll();
        svs.tipset.models.xpertenSystemsSingleRow.clearAll();
      } else {
        svs.tipset.collections.matchlist.clearAll();
        svs.tipset.models.xpertenSystems.clearAll();
        svs.tipset.models.betslipFooter.resetBetslip();
        svs.tipset.models.systems.clear();
      }
    },

    getCenterButtonText: function() {
      var centerButtonText = '',
        noOfRows = this.model.get('xperten').size;

      if (svs.tipset.models.play.get('isSingleMode') && noOfRows == 1) {
        centerButtonText = noOfRows + ' rad';
      } else if (this.model.get('xperten').type == 'R') {
        var currentSystem = this.model.get('xperten');
        centerButtonText =
          currentSystem.type +
          '-' +
          currentSystem.full +
          '-' +
          currentSystem.half +
          '-' +
          currentSystem.rows +
          '(' +
          currentSystem.guaranty +
          ')';
      } else {
        centerButtonText = noOfRows + ' rader';
      }

      return centerButtonText;
    },

    updateSwiper: function() {
      if (!svs.core.detect.formfactor.mobile()) {
        svs.tipset.multiSwiper.updateSize();
      }
    },

    removeActionBar: function() {
      svs.sport.actionbar.hide();
    }
  });
})(Backbone, _, svs);

 })(window);